import React from 'react'

type Props = {
    title?: string
    className?: string
}

const DownloadIcon: React.FC<Props> = ({ title, className }) => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 25 25"
        fill="none"
        style={{ marginRight: '10px' }}
        className={className}
        xmlns="http://www.w3.org/2000/svg">
        <title>{title}</title>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.75 1.75C12.75 1.33579 12.4142 1 12 1C11.5858 1 11.25 1.33579 11.25 1.75V15.0164L6.93738 10.1288C6.66333 9.81819 6.18938 9.78857 5.87878 10.0626C5.56819 10.3367 5.53857 10.8106 5.81262 11.1212L11.4376 17.4962C11.5774 17.6546 11.7775 17.7467 11.9887 17.7499C12.1999 17.7531 12.4027 17.6671 12.5472 17.513L18.1722 11.513C18.4555 11.2108 18.4401 10.7361 18.138 10.4528C17.8358 10.1695 17.3611 10.1849 17.0778 10.487L12.75 15.1034V1.75ZM4.125 16.25C4.125 15.8358 3.78921 15.5 3.375 15.5C2.96079 15.5 2.625 15.8358 2.625 16.25V22.25C2.625 22.6642 2.96079 23 3.375 23H20.625C21.0392 23 21.375 22.6642 21.375 22.25V16.25C21.375 15.8358 21.0392 15.5 20.625 15.5C20.2108 15.5 19.875 15.8358 19.875 16.25V21.5H4.125V16.25Z"
            fill="#455D82"
        />
    </svg>
)

export default DownloadIcon
